import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './CategoryCard.css';

const { FiArrowRight, FiCheck } = FiIcons;

const CATEGORY_THEMES = {
  'Hibiscus Flowers': {
    accent: '#E11D48',
    pillBg: 'rgba(225, 29, 72, 0.08)',
    pillColor: '#BE123C',
    tag: 'Antioxidant & Tart',
    count: '18+ Items'
  },
  'Dry Blue Lotus': {
    accent: '#5a30ba',
    pillBg: 'rgba(90, 48, 186, 0.08)',
    pillColor: '#4625a0',
    tag: 'Calming & Sacred',
    count: '12+ Items'
  },
  'Butterfly Pea Flowers': {
    accent: '#3d29ba',
    pillBg: 'rgba(61, 41, 186, 0.08)',
    pillColor: '#2d1f8a',
    tag: 'Vibrant & Color-Shifting',
    count: '24+ Items'
  },
  'Rose Petals': {
    accent: '#e07287',
    pillBg: 'rgba(244, 160, 176, 0.16)',
    pillColor: '#c24b64',
    tag: 'Aromatic & Floral',
    count: '16+ Items'
  }
};

function CategoryCard({ category, index = 0 }) {
  const theme = CATEGORY_THEMES[category.title] || {
    accent: '#0e8f5b',
    pillBg: 'rgba(14, 143, 91, 0.08)',
    pillColor: '#087448',
    tag: 'Pure Origin',
    count: 'All Varieties'
  };

  return (
    <Link
      to="/shop"
      className="modern-category-card home-category-card group"
      style={{ '--cat-accent': theme.accent }}
    >
      <div className="cat-card-glass-glow" />

      <div className="cat-card-top">
        <div
          className="cat-card-tag"
          style={{ background: theme.pillBg, color: theme.pillColor }}
        >
          <SafeIcon icon={FiCheck} />
          <span>{theme.tag}</span>
        </div>
      </div>

      <div className="cat-card-visual">
        <div className="cat-visual-aura" />
        <img
          src={category.image}
          alt={category.title}
          loading="lazy"
          className="cat-main-img"
        />
      </div>

      <div className="cat-card-bottom">
        <div className="cat-info-group">
          <span className="cat-micro-label">Botanical Harvest</span>
          <h3 className="cat-title">{category.title}</h3>
          <p className="cat-desc">{category.description}</p>
        </div>

        <div className="cat-action-row">
          <span className="cat-action-text">Explore Selection</span>
          <div className="cat-action-circle">
            <SafeIcon icon={FiArrowRight} />
          </div>
        </div>
      </div>
    </Link>
  );
}

export default CategoryCard;